import FinanceApi from '@/services/FinanceApi';

const getAll = async (config) => {
    return FinanceApi.get('/payment/packages', config);
}

const get = async (id) => {
    return FinanceApi.get('/payment/packages/' + id);
}

const store = async (data) => {
    if (data.id) {
        return FinanceApi.put('/payment/packages/' + data.id, data);
    }
    return FinanceApi.post('/payment/packages', data);
}

const update = async (id, formData) => {
    return FinanceApi.put('/payment/packages/' + id, formData);
}

const del = async (id) => {
    return FinanceApi.delete('/payment/packages/' + id);
}

const getProducts = async (id) => {
    return FinanceApi.get('/payment/packages/' + id +'/products');
}

export default {
    getAll,
    get,
    store,
    update,
    del,
    getProducts
}
